import { render, staticRenderFns } from "./RoleAttachmentsBadge.vue?vue&type=template&id=4a94747c&scoped=true"
import script from "./RoleAttachmentsBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleAttachmentsBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RoleAttachmentsBadge.vue?vue&type=style&index=0&id=4a94747c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94747c",
  null
  
)

export default component.exports